import { versions } from "./versions";

export const environment = {
  production: true,
  origin: "https://api.prod.genalyte.com",
  envName: "prod",
  versions,
  domain: "physicians.genalyte.com"
};



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/environments/environment.ts